import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CuitPipe } from '@webapp/core/pipes/cuit.pipe';
import { formatDNI } from '@webapp/core';
import { IUserDetail, USER_TYPES } from '../../../interfaces/users.interface';

@Component({
  selector: 'app-profile-info',
  standalone: true,
  imports: [DatePipe],
  providers: [CuitPipe],
  templateUrl: './profile-info.component.html',
  styleUrl: './profile-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileInfoComponent {
  private readonly cuitPipe = inject(CuitPipe);

  profile = input<IUserDetail | null>(null);

  isCompany = computed(() => this.profile()?.type === USER_TYPES.COMPANY);

  isAgent = computed(() => this.profile()?.role === 'AGENT');

  formattedIdentification = computed(() => {
    const profile = this.profile();
    if (!profile?.identification) return '';

    return profile.type === USER_TYPES.PERSON
      ? formatDNI(profile.identification) ?? ''
      : this.cuitPipe.transform(profile.identification) ?? '';
  });
}
